// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { selectOptionsModalStyles } from "@awc/App/Components/Product/SelectOptionsModal";
import { mergeWithCss } from "@awc/XDL/Utilities";
import { css } from "styled-components";

selectOptionsModalStyles.modal = {
    sizeVariant: "small",
    headlineTypographyProps: {
        variant: "h6",
        css: css`
                margin-bottom: 0;
            `,
    },
};

selectOptionsModalStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr;
        gap: 12px;
    `,
};

selectOptionsModalStyles.productUnitOfMeasureSelect = {
    cssOverrides: {
        formField: css`
            max-width: 136px;
        `,
    },
};

selectOptionsModalStyles.productQuantityOrdered = {
    cssOverrides: {
        formField: css`
            max-width: 70px;
        `,
        inputSelect: css`
            text-align: center;
        `,
    },
};

selectOptionsModalStyles.productAddToCartButton = {
    css: css`
        width: 100%;
    `,
};
selectOptionsModalStyles.qtyWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 5px;
    `,
};